import { render, staticRenderFns } from "./VSlider.vue?vue&type=template&id=c282b70c&"
import script from "./VSlider.vue?vue&type=script&lang=ts&"
export * from "./VSlider.vue?vue&type=script&lang=ts&"
import style0 from "./VSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports